import React, { useContext } from 'react';
import { SettingsContext } from '../context';
import { useTranslation } from 'react-i18next';
import AgreementForm from './AgreementForm';
import DocsTerms from './DocsTerms';

/**
 * Terms Form, Step from @see AgreementsApprove
 * @param props
 */
export default function(props: {
  onChange: (checked: boolean) => void;
  value: boolean;
}) {
  const { language } = useContext(SettingsContext);
  const { t } = useTranslation();
  return (
    <AgreementForm
      label={t('agreementTerms')}
      onChange={props.onChange}
      value={props.value}
    >
      <DocsTerms lng={language || 'en'} />
    </AgreementForm>
  );
}
